import type { FetchPartnerUsersListQuery } from '@/features/users/api'
import type { PartnerUsersRequestQuery } from '@/libs/api/types'

export function buildFetchPartnerUserQuery(
  tenantKey: string,
  deps: PartnerUsersRequestQuery
): FetchPartnerUsersListQuery {
  return {
    tenantKey,
    query: {
      ...deps
    }
  }
}
